const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';

const _ = {
    find:       require('lodash/find'),
    forEach:    require('lodash/forEach'),
    get:        require('lodash/get'),
    isEqual:    require('lodash/isEqual'),
    isEmpty:    require('lodash/isEmpty'),
};

import ProgressButton from '@muzzylane/react-progress-button';

import WithSiteMaintenanceMode from '../DataHOCs/WithSiteMaintenanceMode';
import WithShortCourseDoc from '../DataHOCs/WithShortCourseDoc';
import WithChannelActivities from '../DataHOCs/WithChannelActivities';
import WithChannelProjects from '../DataHOCs/WithChannelProjects';

import TopNav from '../DashboardNew/Menu/TopNav';
import WarningBox from '../common/WarningBox';
import ThreeModal from '../modal/ThreeModal';
import SingleInputModal from '../modal/SingleInputModal2';
import GenericTextInputModal from '../modal/GenericTextInputModal';
import IFrame from '../IFrame';
import LoadingMainContent from '../loading/LoadingMainContent';
import HelpDropdown from '../nav/HelpDropdown';

const ShortCourseActions = require('../../actions/ShortCourseActions');
const ShortCourseStore = require('../../stores/ShortCourseStore');
import ShortCoursePlayStore from '../../stores/ShortCoursePlayStore';

const ActivityActions = require('../../actions/ActivityActions');
// const ActivityStore = require('../../stores/activity_store_reflux');

const CourseWebsocketActions = require('../../actions/CourseWebsocketActions');
const CourseWebsocketStore = require('../../stores/CourseWebsocketStore');
const SignInStore = require('../../stores/SignInStore');

const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');
const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');
const TemplateStore = require('../../stores/template_store_reflux');

const BadgeActions = require('../../actions/BadgeActions');
const BadgeStore = require('../../stores/BadgeStore');

const RSDActions = require('../../actions/RSDActions');
const RSDStore = require('../../stores/RSDStore');

import EditShortCourse from './EditShortCourse';

import { PreviewShortCourse } from './PreviewShortCourseView';

const propTypes = {
    history: PropTypes.object.isRequired,
	shortCourse: PropTypes.object.isRequired,
	doc: PropTypes.object.isRequired,
    projectStoreState: PropTypes.shape({ initialized: PropTypes.bool, projects: PropTypes.array }).isRequired,
    activityStoreState: PropTypes.shape({ initialized: PropTypes.bool, activities: PropTypes.object }).isRequired,
};
const defaultProps = {};

class EditShortCourseViewComponent extends React.Component {
    constructor(props) {
        super(props);

        this.buildActivitySelectorData = this.buildActivitySelectorData.bind(this); // required to ensure 'this' is available in first call
        const { projects, activities, templates, pendingMetaData } = this.buildActivitySelectorData();
        ShortCourseEditorActions.initializeEditorDoc(uuid.v4(), props.doc, activities);
        let badgeStoreState = BadgeStore.getStateChannel(props.channelId);
        let badgeTemplates = badgeStoreState.badgeTemplates || [];
        let pendingBadgeActionId = null;
        if (!badgeStoreState.initialized) {
            pendingBadgeActionId = uuid.v4();
            BadgeActions.getChannelBadgeTemplates(pendingBadgeActionId, {channelId:props.channelId});
        }
        
        let courseCommentInfo = ShortCourseStore.getState().courseCommentInfo[props.shortCourseId];
        let pendingCommentInfoId = null;
        if (!courseCommentInfo) {
            pendingCommentInfoId = uuid.v4();
            ShortCourseActions.getCommentInfo(pendingCommentInfoId,{shortCourseId:props.shortCourseId});
        }
        
        this.state = { 
            projects,
            activities,
            templates,
            pendingMetaData,
            mode: 'EDIT',
            editedDoc: null,
            errorLines: [],
            selectedNode: null,
            unsavedChanges: false,
            modalState: {
                save: false,
                closeUnsaved: false,
                rich_text_editor: false,
            },
            iframe_url: null,
            courseWebsocketStoreState: CourseWebsocketStore.getState(),
            badgeTemplates, pendingBadgeActionId, 
            courseCommentInfo, pendingCommentInfoId,
        };
        this.unsubscribes = [
            ShortCourseEditorStore.listen(this.onEditedDocChange),
            ShortCourseStore.listen(this.onShortCourseStoreChange),
            CourseWebsocketStore.listen(this.onCourseWebsocketStoreChange),
            BadgeStore.listen(this.onBadgeStoreChange),
            RSDStore.listen(this.onRSDStoreChange),
        ];
    }

    componentDidMount() {
        this.setupWs();
        this.prepRDS();
    }
    
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.projectStoreState.initialized && nextProps.activityStoreState.initialized) {
            let activitySelectorChange = false;
            if (!this.props.projectStoreState.initialized || !this.props.activityStoreState.initialized) {
                activitySelectorChange = true;
            }
            else {
                if (!_.isEqual(this.props.projectStoreState.projects, nextProps.projectStoreState.projects)) {
                    activitySelectorChange = true;
                }
                else if (!_.isEqual(this.props.activityStoreState.activities, nextProps.activityStoreState.activities)) {
                    activitySelectorChange = true;
                }
            }

            if (activitySelectorChange) {
                let {projects,activities,templates} = this.buildActivitySelectorData();
                this.setState({projects,activities,templates});
            }
        }
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        if (this.errorTimer) {
            clearTimeout(this.errorTimer);
        }
    }
    
    refreshComments=()=>{
        if (!this.state.pendingCommentInfoId) {
            let pendingCommentInfoId = uuid.v4();
            this.setState({pendingCommentInfoId});
            ShortCourseActions.getCommentInfo(pendingCommentInfoId,{shortCourseId:this.props.shortCourseId});
        }
    }
    
    commentAction=(commentAction)=>{
        let updateCommentActionId = uuid.v4();
        this.setState({updateCommentActionId},()=>{
            ShortCourseActions.updateComment(updateCommentActionId,{
                shortCourseId:this.props.shortCourseId,
                commentAction,
            });
        });
    }
    
    prepRDS=()=>{
        // gather rsid information
        let rsd_queries = [];
        let incomplete_rsd_ids = []; // rsd_ids without an associated service id (from old docs)
        _.forEach(this.props.doc.subskills,(subskill)=>{
            let {rsd_id, rsd_service_id} = subskill;
            if (rsd_id) {
                if (!rsd_service_id) {
                    if (incomplete_rsd_ids.indexOf(rsd_id) < 0) {
                        incomplete_rsd_ids.push(rsd_id);
                    }
                }
                else {
                    let q = {rsd_id, rsd_service_id};
                    if (!_.find(rsd_queries,q)) {
                        rsd_queries.push(q);
                    }
                }
            }
        });
        if (incomplete_rsd_ids.length || rsd_queries.length) {
            let rsd_prep = {};
            if (incomplete_rsd_ids.length) {
                rsd_prep.service_match_actionId = uuid.v4();
            }
            if (rsd_queries.length) {
                rsd_prep.lookup_actionId = uuid.v4();
            }
            this.setState({rsd_prep},()=>{
                if (incomplete_rsd_ids.length) {
                    RSDActions.findMatchingServices(rsd_prep.service_match_actionId,{channelId: this.props.channelId, rsd_ids:incomplete_rsd_ids});
                }
                if (rsd_queries.length) {
                    RSDActions.batchLookup(rsd_prep.lookup_actionId,{channelId: this.props.channelId, rsd_queries});
               }
            });
        }
    
    }
    
    buildActivitySelectorData = () => {
        const curentStatePendingMetaData = _.get(this, ['state', 'pendingMetaData'], []); // required to ensure array since buildActivitySelectorData is called prior to state init in constructor
        const storeProjects = (this.props.projectStoreState && this.props.projectStoreState.initialized && this.props.projectStoreState.projects) || [];
        const storeActivities = (this.props.activityStoreState && this.props.activityStoreState.initialized && this.props.activityStoreState.activities) || {}; // keyed by project
        
        // flatten project out of activities and remove projects without any activities to choose from
        let projects = {};
        let activities = [];
        let need_full_info_ids = [];
        _.forEach(storeActivities, (projActivities, proj_id) => {
            let publishedActivities = [];
            _.forEach(projActivities,(activity) => {
                if (activity.ever_published && activity.latest_published_version) {
                    publishedActivities.push({
                        id: activity.id,
                        activity_id: activity.activity_id,
                        version: activity.latest_published_version,
                        project_id: activity.project_id,
                        template_id: activity.template_id,
                        title: activity.title,
                    });
                    if (
                        (
                            !activity.meta_data
                            || !activity.meta_data.saveDate
                            || (typeof activity.title === 'undefined')
                        )
                        && !curentStatePendingMetaData.find(getObj => getObj.activityId === activity.id) // TEMP hacky optimization to prevent duplicate activity requests. TODO rework this data fetching pattern
                    ) { // If there's not a saveDate, we don't have the full meta_data
                        // console.log(`requesting full info for activity`);
                        need_full_info_ids.push(activity.id);
                    }
                }
            });

            if (publishedActivities.length) {
                let p = _.find(storeProjects,{id:Number(proj_id)});
                projects[proj_id] = { name: p.name }; // that's all we need
                activities = activities.concat(publishedActivities);
            }

        });
        
        // massage templates into an object keyed by template_id
        const template_array = TemplateStore.getState().globalTemplates;
        let templates = {};
        _.forEach(template_array,(elem) => {
            templates[elem.id] = {
                name: elem.name,
                template_url: elem.template_url,
            }
        });
        
        let pendingMetaData = [];
        if (need_full_info_ids.length) {
            //console.log(`requesting full info for ${need_full_info_ids.length} activities`);
            _.forEach(need_full_info_ids,(activityId) => {
                let actionId = uuid.v4();
                ActivityActions.getActivity(actionId, {activityId});
                pendingMetaData.push({actionId,activityId});
            });
        }
        
        return {projects, activities, templates, pendingMetaData};
    }
    
    onCourseWebsocketStoreChange = (storeState) => {
        if (
            storeState.action.id === this.state.releaseLockActionId
            && this.state.closeAfterRelease
        ) { // regardless of error
            console.debug('closing after lock released...');
            this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}`);
            return;
        }

        const currentlyHaveLock = !!storeState.cWebsocket && !!storeState.cWebsocket._haveLock && !storeState.connection_lost;
        const lockId = currentlyHaveLock ? storeState.cWebsocket.lockId : -1;

        let forceClosedSeconds = this.state.forceClosedSeconds;
        // if (currentlyHaveLock && state.force_unlock_data) {
        //     if (!this.state.courseWebsocketStoreState.force_unlock_data) {
        //         // start our close countdown. This can't be cancelled.
        //         if (this.forceClosedTimer) {
        //             console.log("keeping previous forceClosedTimer"); // let the existing timer run out
        //         }
        //         else {
        //             const now = new Date();
        //             const elapsed = now - state.force_unlock_data.start_time;
        //             const remaining = state.force_unlock_data.timeout_ms - elapsed;
        //             const seconds = Math.floor(remaining / 1000);
        //             forceClosedSeconds = Math.max(2,seconds); // allow at least 2 seconds
        //             this.forceClosedTimer = window.setTimeout(this.tickForceClosedCountdown.bind(this, forceClosedSeconds - 1), 1000);
        //         }
        //     }
        // }

        this.setState({
            courseWebsocketStoreState: storeState,
            hadLockOnce: this.state.hadLockOnce || currentlyHaveLock,
            currentlyHaveLock: currentlyHaveLock,
            lockId: lockId,
            // forceClosedSeconds: forceClosedSeconds
        });
    }
    
    onBadgeStoreChange=(storeState)=>{
        if (storeState.action && (storeState.action.id === this.state.pendingBadgeActionId)) {
            if (storeState.action.error) {
                console.log("BadgeStore error:",storeState.action.error);
            }
            else {
                let badgeStoreState = BadgeStore.getStateChannel(this.props.channelId);
                let badgeTemplates = badgeStoreState.badgeTemplates || [];
                let pendingBadgeActionId = null;
                //if (!badgeStoreState.initialized) {
                //    pendingBadgeActionId = uuid.v4();
                //    BadgeActions.getChannelBadgeTemplates(pendingBadgeActionId, {channelId:this.props.channelId});
                //}
                //console.log("got badgeTemplates:",badgeTemplates);
                this.setState({badgeTemplates,pendingBadgeActionId});
            }
        }
    }
    
    onRSDStoreChange=(storeState)=>{
        let rsd_prep = {...this.state.rsd_prep};
        if (rsd_prep && storeState.action) {
            //console.log("onRSDStoreChange, rsd_prep = " + JSON.stringify(rsd_prep));
            if (rsd_prep.service_match_actionId && (rsd_prep.service_match_actionId === storeState.action.id)) {
                delete rsd_prep.service_match_actionId;
                let rsdState = RSDStore.getStateChannel(this.props.channelId).rsdServices;
                if (rsdState && rsdState.matching_services) {
                    // fill in all the missing rsd_service_ids with the first matching service
                    // (assumes there is only one matching rsd service for a given rsd_id url)
                    _.forEach(this.state.editedDoc.subskills,(subskill)=>{
                        let {rsd_id, rsd_service_id} = subskill;
                        if (rsd_id && !rsd_service_id) {
                            // see if any services match the rsd_id
                            _.forEach(rsdState.matching_services, (rsd_ids,rsd_service_id)=>{
                                if (rsd_ids.indexOf(rsd_id) >= 0) {
                                    console.log(`Matched rsd_id ${rsd_id} with service ${rsd_service_id} for subskill ${subskill.display_name}`);
                                    ShortCourseEditorActions.setSubskillValue(uuid.v4(), subskill.node_id, subskill.hash, 'rsd_service_id', rsd_service_id);
                                    return false;
                                }
                            });
                        }
                    });
                }
            }
            else if (rsd_prep.lookup_actionId && (rsd_prep.lookup_actionId === storeState.action.id)) {
                delete rsd_prep.lookup_actionId;
                // we don't need to do anything else
            }
            if (_.isEmpty(rsd_prep)) {
                rsd_prep = null;
            }
            this.setState({rsd_prep});
        }
    }

    setupWs = () => {
        const self = this;
        this.setState({
            getLockTimer: window.setInterval(() => {
                if (!!self.props.shortCourse) {
                    window.clearInterval(self.state.getLockTimer);
                    self.setState({ getLockTimer: null, lockProcessBegun: true}, () => {
                        CourseWebsocketActions.getCourseLock(uuid.v4(), {
                            courseId: self.props.shortCourse.hash,
                            userId: SignInStore.getState().userInfo.hash,
                        })
                    });
                }
            }, 2000)
        })
    }

    /*ensureLockReleased = () => {
        CourseWebsocketActions.ensureLockReleased(
            uuid.v4(),
            {
                cWebsocket: this.state.courseWebsocketStoreState.cWebsocket,
                connectionLost: this.state.courseWebsocketStoreState.connection_lost,
                lockProcessBegun: this.state.lockProcessBegun,
            }
        );
    }*/

    releaseLockAndClose = () => {
        const releaseLockActionId = uuid.v4();
        this.setState({
            releaseLockActionId: releaseLockActionId,
            closeAfterRelease: true,
            lockProcessBegun: false,
        }, () => {
            CourseWebsocketActions.ensureLockReleased(
                releaseLockActionId,
                {
                    cWebsocket: this.state.courseWebsocketStoreState.cWebsocket,
                    connectionLost: this.state.courseWebsocketStoreState.connection_lost,
                    lockProcessBegun: this.state.lockProcessBegun,
                }
            );
        })
    }
    
    updateErrors = (newError, callback) => {
        let errorLines = this.state.errorLines.slice();
        if (newError) {
            errorLines.push(newError);
        }
        else {
            delete this.errorTimer;
            errorLines.shift();
        }
        this.setState({ errorLines },() => {
            if (errorLines.length) {
                if (!this.errorTimer) {
                    this.errorTimer = setTimeout(() => {this.updateErrors()}, 5000);
                }
            }

            if (!!callback) callback();
        });
    }

    onShortCourseStoreChange = (storeState) => {
        if (storeState && storeState.action && storeState.action.id) {
            if (storeState.action.id === this.state.imageUpdateActionID) {
                if (storeState.action.error) {
                    this.updateErrors(storeState.action.error, () => {
                        this.setState({
                            imageUpdateActionID : null,
                        });
                    });
                }
                else {
                    this.setState({imageUpdateActionID: null});
                }
            }
            else if (storeState.action.id === this.state.pendingSaveActionId) {
                if (storeState.action.error) {
                    this.updateErrors(storeState.action.error, () => {
                        this.setState({
                            saveButtonState: 'error',
                            pendingSaveActionId : null,
                        });
                    });
                }
                else {
                    let postSaveAction = this.state.postSaveAction;
                    this.setState({
                        unsavedChanges:false, 
                        pendingSaveActionId: null, 
                        postSaveAction: null, 
                        saveButtonState: ''
                    },() => {
                        switch(postSaveAction) {
                            case 'close':
                                this.onClose();
                                break;
                            case 'preview':
                                this.onPreview();
                                break;
                            case 'previewActivity':
                                this.onPreviewActivity(this.state.preview_activity_id);
                                break;
                        }
                    });
                }
            }
            else if (storeState.action.id === this.state.pendingCommentInfoId) {
                if (storeState.action.error) {
                    this.updateErrors(storeState.action.error, () => {
                        this.setState({
                            pendingCommentInfoId : null,
                        });
                    });
                }
                else {
                    let courseCommentInfo = storeState.courseCommentInfo[this.props.shortCourseId];
                    this.setState({
                        courseCommentInfo,
                        pendingCommentInfoId : null,
                    });
                }
            }
            else if (storeState.action.id === this.state.updateCommentActionId) {
                this.setState({updateCommentActionId: null},()=>{
                    this.refreshComments();
                });
                
            }
        }
    }
    
    onEditedDocChange = (storeState) => {
        let unsavedChanges = this.state.unsavedChanges;
        // let pendingPublishActionId = this.state.pendingPublishActionId;
        if (storeState.action) {
            // if (storeState.action.id === pendingPublishActionId) {
            //     pendingPublishActionId = null;
            // }
            if (storeState.action.error) {
                this.updateErrors(storeState.action.error);
            }
            else {
                switch(storeState.action.name) {
                    case 'initializeEditorDoc':
                    case 'selectNode':
                        break;
                        
                    default:
                        //console.log(`action ${storeState.action.name} triggering unsavedChanges true`);
                        unsavedChanges = true;
                }
            }
        }
        
        const editedDoc = {...storeState.shortCourseDoc}; // clone
        const selectedNode = _.find(editedDoc.nodes, { node_id:storeState.selectedNodeId });

        this.setState({ editedDoc, selectedNode, unsavedChanges/*, pendingPublishActionId*/ });
    }
    
    onCloseActivityPreview = () => {
        this.setState({ iframe_url: null });
    }
    
    setSaveModalState = (showBool, postSaveAction, saveDefaultMessage) => {
        this.setState({ 
            modalState: { ...this.state.modalState, save: showBool },
            postSaveAction: postSaveAction || null, // postSaveAction can be 'preview', 'close' or nothing
            saveDefaultMessage: saveDefaultMessage || '',
        });
    }
    
    setCloseUnsavedModalState = (showBool) => {
        this.setState({ modalState: { ...this.state.modalState, closeUnsaved: showBool } });
    }
    
    onSave = () => {
        this.setSaveModalState(true);
    }
    
    save = (message) => {
        let pendingSaveActionId = uuid.v4();
        this.setState({
            pendingSaveActionId,
            modalState: { ...this.state.modalState, save: false },
            saveButtonState: 'saving',
        }, () => {
            ShortCourseActions.saveShortCourseVersion(pendingSaveActionId,{
                channelId: this.props.channelId,
                shortCourseId: this.props.shortCourseId,
                doc: { ...this.state.editedDoc, save_message: message },
            });
        });
    }
    
    saveAndClose = () => {
        this.setSaveModalState(true, 'close');
    }
    
    closeWithoutSaving = () => {
        this.setState({ unsavedChanges: false }, this.onClose);
    }
    
    onClose = () => {
        if (this.state.unsavedChanges) {
            this.setCloseUnsavedModalState(true);
        }
        else {
            this.releaseLockAndClose();
            // this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}`);
        }
    }

    onPreview = () => {
        if (this.state.unsavedChanges) {
            this.setSaveModalState(true, 'preview', 'Save for Preview');
        }
        else {
            this.setState({ mode: 'PREVIEW' });
            // this.props.history.push(`/project/${this.props.channelId}/${this.props.projectId}/short_course/${this.props.shortCourseId}/preview`);
        }
    }

    onEdit = () => {
        this.setState({ mode: 'EDIT' });
    }

    onPreviewActivity = (activity_id) => {
        if (this.state.unsavedChanges) {
            this.setState({ preview_activity_id: activity_id }, () => {
                this.setSaveModalState(true, 'previewActivity', 'Save for Activity Preview');
            });
        }
        else {
            const cb = _.find(this.state.editedDoc.content_blocks,{nova_activity_id:activity_id});
            if (!cb) {
                console.log(`unable to find content block with activity id ${activity_id}`);
                return;
            }

            const activity = _.find(this.state.activities,{activity_id});
            if (!activity) {
                console.log(`unable to find activity id ${activity_id}`);
                return;
            }

            const template = this.state.templates[activity.template_id];
            if (!template) {
                console.log(`unable to find template id ${activity.template_id}`);
                return;
            }

            let params = ShortCoursePlayStore.getStaticShortCoursePlayParams(); // for preview of a single activity
            this.setState({
                preview_activity_id: null,
                iframe_url: `${template.template_url}/demo/web/${cb.nova_activity_id}/${cb.activity_version}${params}`
            });
        }
    }

    updateImage=(assetParams, files)=>{
        const imageUpdateActionID = uuid.v4();
        let params = {...assetParams, 
            courseHash: this.props.shortCourse.hash,
            asset_name: `course ${this.props.shortCourseId} bg image`
        };
        this.setState({ imageUpdateActionID },()=>{
            // after updating state, upload the image
            ShortCourseActions.addShortCourseVersionAsset(imageUpdateActionID, params, files, (asset_url)=>{
                // after uploading the image, set the bg url
                this.setState({bgImg: asset_url, imageUpdateActionID: null},()=>{
                    ShortCourseEditorActions.setBackground(uuid.v4(),asset_url);
                });
            });
        });
    }

    removeImage=()=>{
        //const imageUpdateActionID = uuid.v4();
        this.setState({ imageUpdateActionID: null },()=>{
            ShortCourseEditorActions.setBackground(uuid.v4(),'');
        });
    }

    updateImageOnError=(errorMsg)=>{
        this.updateErrors(errorMsg || 'Image Upload Error', ()=>{this.setState({imageUpdateActionID:null})});
    }

    render() {
        let mainContent;
        let showEditorTopBar = true;
        if (this.state.courseWebsocketStoreState.error && !this.state.hadLockOnce) {
            mainContent = (
                <div className="mzlIFrame--other">
                    <WarningBox>
                        {this.state.courseWebsocketStoreState.error.error}
                        <span style={{display:'none'}} aria-hidden={true}>
                            Step: {this.state.courseWebsocketStoreState.error.step}
                        </span>
                    </WarningBox>
                </div>
            );
        }
        else if (this.state.courseWebsocketStoreState.connection_perm_lost) {
            mainContent = (
                <div className="mzlIFrame--other">
                    <WarningBox>
                        Editing lock lost.
                    </WarningBox>
                </div>
            );
        }
        else {
            if (this.state.mode === 'EDIT') {
                if (!this.state.currentlyHaveLock && !this.state.hadLockOnce) { // negotiating initial lock
                    mainContent = (
                        <div className="mzlIFrame--other">
                            <LoadingMainContent />
                        </div>
                    );
                }
                else if (this.state.rsd_prep) {
                    mainContent = (
                        <div className="mzlIFrame--other">
                            <LoadingMainContent />
                            <div className="centered-vh">Loading Skill Data</div>
                        </div>
                    );
                }
                else {
                    mainContent = (
                        <EditShortCourse
                            channelId={this.props.channelId}
                            shortCourse={this.props.shortCourse}
                            projects={this.state.projects}
                            activities={this.state.activities}
                            templates={this.state.templates}
                            badgeTemplates={this.state.badgeTemplates}
                            editedDoc={this.state.editedDoc}
                            errorLines={this.state.errorLines}
                            selectedNode={this.state.selectedNode}
                            onPreviewActivity={this.onPreviewActivity}
                            onUpdateImage={this.updateImage}
                            onUpdateImageError={this.updateImageOnError}
                            onRemoveImage={this.removeImage}
                            imageUpdateActionID={this.state.imageUpdateActionID}
                            courseCommentInfo={this.state.courseCommentInfo}
                            refreshComments={this.refreshComments}
                            commentAction={this.commentAction}
                            reviewMode={this.props.reviewMode}
                        />
                    );
                }

            }
            else if (this.state.mode === 'PREVIEW') {
                mainContent = (
                    <PreviewShortCourse
                        channelId={this.props.channelId}
                        projectId={this.props.projectId}
                        shortCourseId={this.props.shortCourseId}
                        shortCourse={this.props.shortCourse}
                        doc={this.props.doc}
                        projectStoreState={this.props.projectStoreState}
                        activityStoreState={this.props.activityStoreState}
                        askToExitCourse={this.state.currentlyHaveLock ? this.onEdit : null}
                    />
                );
                showEditorTopBar = false;
            }
            else {
                console.error('Invalid editor mode');
                mainContent = null;
            }

        }

        if (this.state.iframe_url) {
            return (
                <div className="short-course-editor">
                    <TopNav logoLinkDisable>
                        <HelpDropdown />
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onCloseActivityPreview}>
                            Close Preview
                        </Button>
                    </TopNav>
                    <div className="preview-url">
                        <IFrame ref="iframe" url={this.state.iframe_url}/>
                    </div>
                </div>
            );
        }
        return (
            <div className="short-course-editor">
                { showEditorTopBar ? 
                <TopNav logoLinkDisable>
                    <HelpDropdown />
                    {(this.state.mode === 'PREVIEW') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onEdit} disabled={!this.state.currentlyHaveLock}>
                            Edit
                        </Button>
                    }
                    {(this.state.mode === 'EDIT') &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onPreview} disabled={!this.state.currentlyHaveLock}>
                            Preview
                        </Button>
                    }
                    {(this.state.mode === 'EDIT' || !this.state.currentlyHaveLock) &&
                        <Button variant="light" className="editorButton margin-right-md" onClick={this.onClose}>
                            Close
                        </Button>
                    }
                    {(this.state.mode === 'EDIT' && this.state.currentlyHaveLock) &&
                        <div className={!this.state.unsavedChanges ? 'save-button disabled' : 'save-button'}>
                            <ProgressButton state={this.state.saveButtonState} onClick={this.onSave}>
                                Save
                            </ProgressButton>
                        </div>
                    }
                </TopNav> : null }
                {mainContent}
                {(!this.state.currentlyHaveLock && this.state.hadLockOnce) &&
                    <div className="editor-blocker">
                        <WarningBox>Lost lock connection. <br/> Reconnecting...</WarningBox>
                        <LoadingMainContent/>
                    </div>
                }
                {(this.state.modalState['save']) &&
                    <SingleInputModal
                        show
                        multiline
                        headerText="Save Course"
                        inputLabel="Save Message"
                        ariaLabel="Save Message"
                        buttonText="confirm"
                        closeHandler={() => {this.setSaveModalState(false)}}
                        submitHandler={this.save}
                        defaultValue={this.state.saveDefaultMessage}
                    >
                        {/*(this.state.save_validation) &&
                            <div className="margin-top-lg">
                                <h2 className="margin-bottom-md">Validation Information</h2>
                                <ValidationReport className="mzl-cs-workarea" validationObj={this.state.save_validation} />
                            </div>
                        */}
                    </SingleInputModal>
                }
                {(this.state.modalState['closeUnsaved']) &&
                    <ThreeModal
                        modalTitle="Unsaved Changes"
                        message="You have unsaved changes. Are you sure you wish to leave this page?"
                        buttonData={[
                            {
                                text: 'Save & Close',
                                handler: this.saveAndClose
                            },
                            {
                                text: 'Discard & Close',
                                handler: this.closeWithoutSaving
                            },
                            {
                                text: 'Cancel',
                                handler: this.setCloseUnsavedModalState.bind(this, false)
                            }
                        ]}
                    />
                }
            </div>
    	);
    }
} // EditShortCourseViewComponent

EditShortCourseViewComponent.propTypes = propTypes;
EditShortCourseViewComponent.defaultProps = defaultProps;

const WrappedComponent = withRouter(WithSiteMaintenanceMode(WithShortCourseDoc(WithChannelProjects(WithChannelActivities(EditShortCourseViewComponent)))));

function EditShortCourseView(props) {
    return (
        <WrappedComponent
            {...props}
            shortCourseId={props.match.params.shortCourseId}
            projectId={props.match.params.projectId}
            channelId={props.match.params.channelId}
        />
    );
}

EditShortCourseView.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            shortCourseId: PropTypes.string.isRequired,
            shortCourseVersion: PropTypes.string,
        }).isRequired,
    }).isRequired,
};

export default EditShortCourseView;